import { render, staticRenderFns } from "./DatiClinicoStrumentaliIctusEditComponent.vue?vue&type=template&id=6e942858&scoped=true"
import script from "./DatiClinicoStrumentaliIctusEditComponent.vue?vue&type=script&lang=js"
export * from "./DatiClinicoStrumentaliIctusEditComponent.vue?vue&type=script&lang=js"
import style0 from "./DatiClinicoStrumentaliIctusEditComponent.vue?vue&type=style&index=0&id=6e942858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e942858",
  null
  
)

export default component.exports